module.exports = __webpack_public_path__ + "img/aaron.15edd56e.jpeg";